import React from 'react';
import cn from 'classnames';

import styles from './CelebritiesHead.module.scss';

const CelebritiesHead = ({classNames, children}) => {
	return <div className={cn(styles['celebrities__head'], classNames)}>{children}</div>;
};

export default CelebritiesHead;
